import fonts from './fonts'

const typeset = {
    fontFamily: fonts.primary,
    h1: {
        // fontFamily: fonts.secondary,
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "25px",
        lineHeight: "120%",
        textAlign:'center'

    },
    h2: {
      // fontFamily: fonts.secondary,
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "22px",
      lineHeight: "120%",
      textAlign:'center'

    },

  

      h3: {
        // fontFamily: fonts.secondary,
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "15px",
        lineHeight: "120%",
        textAlign:'center'

      },
      h4: {
        // fontFamily: fonts.secondary,
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "120%",
       

      },
      p: {
        // fontFamily: fonts.secondary,
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "15px",
        lineHeight: "120%",
        textAlign:'center'

      },
}

export default typeset